import { render, staticRenderFns } from "./IntroductionPsikotest.vue?vue&type=template&id=a4c937d8"
import script from "./IntroductionPsikotest.vue?vue&type=script&lang=js"
export * from "./IntroductionPsikotest.vue?vue&type=script&lang=js"
import style0 from "./IntroductionPsikotest.vue?vue&type=style&index=0&id=a4c937d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports